import { Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DataService } from '@app/shared/common/auth/data.service';
import { VfModalShellComponent } from '@app/shared/common/components/modal-shell/vf-modal-shell.component';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { CreateFileInputDto, CreateFolderDto, FileParameter, GroupLinkDto, LinkServiceProxy, OneDriveServiceProxy } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';

@Component({
  selector: 'vf-file-selector-mobile',
  templateUrl: './file-selector-mobile.component.html'
})
export class FileSelectorMobileComponent extends AppComponentBase implements OnChanges {
  @Input() entity: string;
  @Input() entityObj: any;
  @Input() isOpenFromSlider: boolean;
  @Input() showPopup: boolean;
  @Input() showFolderOnly: boolean;
  @Input() isSingleSelect: boolean;
  @Input() isOpenFolderDirectly: boolean;
  @Input() isFromProject: boolean;
  @Input() folderDetails: any;
  @ViewChild('customMobileModal') customMobileModal: ModalDirective;
  @ViewChild('fsmErrorShell') fsmErrorShell: VfModalShellComponent;
  @Output() onClose = new EventEmitter();
  @Output() selectedItems = new EventEmitter();

  sharePointSitesData: Array<any> = new Array<any>();
  isSaving = false;
  isUploadFiles = false;
  isShowAddItem = false;
  noResultFound = false;
  isFolderEmpty = false;
  fileUploadError = false;
  isShowAddLibrary = false;
  isAllItemsSelected = false;
  isAllDrivesSelected = false;
  isAllLibrarySelected = false;
  isSharePointSitesLoading = false;
  level = 1;
  fileCtrl: any;
  selectedSiteData: any;
  selectedDriveData: any;
  selectedItem: Array<any> = new Array<any>();;
  driveCategoryId: number;
  driveItems: Array<any> = new Array<any>();
  fileRawData: Array<any> = new Array<any>();
  currentItemIndex: number = -1;
  itemsHistory: any[][] = [];
  uploadingItems: any[] = [];
  fileErrorMsg = '';
  searchTextOnL0 = '';
  searchTextOnL2 = '';
  searchTextOnL3 = '';
  searchTextOnL4 = '';
  searchTextOnL5 = '';
  selectedDocType = 1;
  isItemSelected = false;
  noOfSelectedItems = 0;
  nextBatchLink = '';
  isShowInfoPopup = false;
  information = '';
  fsmShellError: { title: string; message: string; cancelLabel?: string; saveLabel?: string } | undefined;
  _fsmLastErrorCode: string | null = null;
  _fsmPendingFileInput: CreateFileInputDto | null = null;
  _fsmPendingFolderInput: CreateFolderDto | null = null;
  _fsmPendingLevel: number = 0;
  _fsmPendingIsOneDrive: boolean = false;
  selectedDriveId = '';
  isMoreDataLoading = false;
  documentName = '';
  fileNameError = false;
  fileNameErrorMessage = '';
  pattern = '^[^\\\\\\/\\:\\*\\?"\\<\\>\\|]+$';

  constructor(injector: Injector,
    private _linkService: LinkServiceProxy,
    private _oneDriveService: OneDriveServiceProxy,
    private dataService: DataService) {
    super(injector);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.doSomething(changes.showPopup.currentValue);
  }

  private getSharepointSites() {
    this.isSharePointSitesLoading = true;
    this._oneDriveService.getSharePointSites('').subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData.length > 0) {
          this.sharePointSitesData = result.responseData;
          this.sharePointSitesData.forEach(element => {
            element.isSelected = false;
          });
        }
      }
    });
  }

  doSomething(condition) {
    if (condition) {
      this.customMobileModal.show();
      this.resetData();
      if (this.isOpenFolderDirectly && this.folderDetails) {
        this.getFolderFilesDirectly();
      } else {
        this.getSharepointSites();
      }
      this.updateBodyForCenterModalShow();
      // // $('body').addClass('deletePopup');
      // if ($('body > *').hasClass('modal-backdrop')) {
      //   $('body').removeClass('task-modal-body');
      //   $('.modal-backdrop:not(:first)').removeClass('modal-backdrop');
      //   // } else {
      //   //   $('body').removeClass('task-modal-body');
      //   $('body').addClass('center-modal-shown');
      // }
    }
  }

  getFolderFilesDirectly() {
    this.level = 0;
    this.initializeSearchOnLevel0();
    this.isSharePointSitesLoading = true;
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(this.folderDetails.driveId, this.folderDetails.itemId, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              if (this.showFolderOnly) {
                if (element.extension === 'folder') {
                  element.isShow = true;
                } else {
                  element.isShow = false;
                }
              } else {
                element.isShow = true;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  resetData() {
    this.level = 1;
    this.isItemSelected = false;
    this.sharePointSitesData = [];
    this.driveItems = [];
    this.selectedItem = [];
    this.driveCategoryId = undefined;
    this.fileRawData = [];
    this.itemsHistory = [];
    this.isSaving = false;
    this.isUploadFiles = false;
    this.isShowAddItem = false;
    this.noResultFound = false;
    this.isFolderEmpty = false;
    this.fileUploadError = false;
    this.isShowAddLibrary = false;
    this.isAllItemsSelected = false;
    this.isAllDrivesSelected = false;
    this.isAllLibrarySelected = false;
    this.isSharePointSitesLoading = false;
    this.selectedSiteData = null;
    this.selectedDriveData = null;
    this.fileErrorMsg = '';
    this.searchTextOnL2 = '';
    this.searchTextOnL3 = '';
    this.searchTextOnL4 = '';
    this.searchTextOnL5 = '';
    this.selectedDocType = 1;
    this.noOfSelectedItems = 0;
  }

  clickClose() {
    if ($('#CreateFileModal').hasClass('show')) {
      $('body').addClass('center-modal-shown');
    } else {
      this.updateBodyForCenterModalHide();
    }
    this.customMobileModal.hide();
    this.onClose.emit();
  }

  private initializeSearchOnLevel0() {
    this.noResultFound = false;
    this.searchTextOnL0 = '';
    $('.level-0-search .input-group-append').hide();
    $('.level-0-search .form-control').on('keyup blur', function () {
      let div = $('.level-0-search .input-group-append');
      if ($('.level-0-search .form-control').val() !== '') {
        $(this).addClass('focus');
        div.show();
      } else {
        div.hide();
        $(this).removeClass('focus');
      }
    });
    $('.level-0-search .input-group-append').on('click', function () {
      $('.level-0-search .form-control').trigger('focus');
    });
  }

  private initializeSearchOnLevel2() {
    this.noResultFound = false;
    this.searchTextOnL2 = '';
    $('.level-2-search .input-group-append').hide();
    $('.level-2-search .form-control').on('keyup blur', function () {
      let div = $('.level-2-search .input-group-append');
      if ($('.level-2-search .form-control').val() !== '') {
        $(this).addClass('focus');
        div.show();
      } else {
        div.hide();
        $(this).removeClass('focus');
      }
    });
    $('.level-2-search .input-group-append').on('click', function () {
      $('.level-2-search .form-control').trigger('focus');
    });
  }

  private initializeSearchOnLevel3() {
    this.noResultFound = false;
    this.searchTextOnL3 = '';
    $('.level-3-search .input-group-append').hide();
    $('.level-3-search .form-control').on('keyup blur', function () {
      let div = $('.level-3-search .input-group-append');
      if ($('.level-3-search .form-control').val() !== '') {
        $(this).addClass('focus');
        div.show();
      } else {
        div.hide();
        $(this).removeClass('focus');
      }
    });
    $('.level-3-search .input-group-append').on('click', function () {
      $('.level-3-search .form-control').trigger('focus');
    });
  }

  private initializeSearchOnLevel4() {
    this.noResultFound = false;
    this.searchTextOnL4 = '';
    $('.level-4-search .input-group-append').hide();
    $('.level-4-search .form-control').on('keyup blur', function () {
      let div = $('.level-4-search .input-group-append');
      if ($('.level-4-search .form-control').val() !== '') {
        $(this).addClass('focus');
        div.show();
      } else {
        div.hide();
        $(this).removeClass('focus');
      }
    });
    $('.level-4-search .input-group-append').on('click', function () {
      $('.level-4-search .form-control').trigger('focus');
    });
  }

  private initializeSearchOnLevel5() {
    this.noResultFound = false;
    this.searchTextOnL5 = '';
    $('.level-5-search .input-group-append').hide();
    $('.level-5-search .form-control').on('keyup blur', function () {
      let div = $('.level-5-search .input-group-append');
      if ($('.level-5-search .form-control').val() !== '') {
        $(this).addClass('focus');
        div.show();
      } else {
        div.hide();
        $(this).removeClass('focus');
      }
    });
    $('.level-5-search .input-group-append').on('click', function () {
      $('.level-5-search .form-control').trigger('focus');
    });
  }

  goToDrivesBySiteId(site) {
    this.isSharePointSitesLoading = true;
    this.isFolderEmpty = false;
    this.level = 2;
    setTimeout(() => {
      this.initializeSearchOnLevel2();
    }, 100);
    this.isShowAddLibrary = false;
    this.selectedSiteData = site;
    this.selectedSiteData.drives = [];
    this._oneDriveService.getDrivesBySiteId(site.id).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        this.level = 2;
        if (result.responseData.length > 0) {
          this.sharePointSitesData.forEach(element => {
            if (element.id === site.id) {
              element.isSelected = true;
              element.drives = result.responseData;
              element.drives.forEach(drive => {
                drive.isSelected = false;
                drive.isShow = true;
              });
              this.selectedSiteData = element;
              this.checkIfItemsToShowOnLevel2();
            }
          });
        } else {
          this.isFolderEmpty = true;
        }
      }
    });
  }

  selectAllLibrary() {
    this.isAllLibrarySelected = !this.isAllLibrarySelected;
    this.selectedSiteData.drives.forEach(element => {
      element.isSelected = this.isAllLibrarySelected;
    });
  }

  backToSelectLocation() {
    this.level = 1;
    this.isFolderEmpty = false;
    this.isShowAddLibrary = false;
    this.selectedSiteData = null;
    this.isItemSelected = false;
  }

  selectDrive(drive) {
    if (this.isSingleSelect) {
      this.selectedSiteData.drives.forEach(element => {
        element.isSelected = false;
      });
    }
    this.isAllLibrarySelected = false;
    drive.isSelected = !drive.isSelected;
    this.isItemSelected = drive.isSelected ? true : false;
    if (this.isSingleSelect) {
      this.noOfSelectedItems = this.isItemSelected ? 1 : 0;
    }
  }

  selectDriveAndSave() {
    let noOfSelectedDrives = this.selectedSiteData.drives.filter(x => x.isSelected).length;
    if (noOfSelectedDrives === 0) {
      let options = this.toastrOptions;
      this.toastr
        .error('Please select at least one library.',
          null, options);
      return;
    } else {
      this.selectedItems.emit([this.selectedSiteData.drives.filter(x => x.isSelected), this.selectedSiteData.id]);
    }
    this.selectedSiteData.drives.forEach(element => {
      if (element.isSelected) {
        noOfSelectedDrives--;
      }
    });
    this.clickClose();
  }

  createLinkToDocLibrary(item, noOfSelectedDrives): void {
    let input: GroupLinkDto = new GroupLinkDto();

    input.type = 3; // 3 for shortcut
    input.name = item.name;
    if (!item.webUrl.startsWith('http')) {
      input.url = 'http://' + item.webUrl;
    } else {
      input.url = item.webUrl;
    }
    input.isShareFile = false; // this.oneDrivePath ? true : false;
    input.isEveryone = true;
    // input.path = this.groupLinkObj.path;
    input.keyId = item.id;
    input.extension = 'documentLibrary';
    input.driveCategoryId = this.driveCategoryId;

    input.driveId = item.id;
    input.siteId = this.selectedSiteData.id;
    this._linkService.createOrUpdateGroupLink(input).subscribe(result => {
      if (!result.isError) {
        if (noOfSelectedDrives === 1) {
          // this.dataService.refreshFilesSlider.next();
          let options = this.toastrOptions;
          this.toastr
            .success('Added to team drive.',
              null, options);
          this.clickClose();
          this.isSaving = false;
        }
      } else {
        if (result.errorMessage.toLocaleLowerCase() === 'duplicate') {
          this.isSaving = false;
          let options = this.toastrOptions;
          this.toastr
            .error('Item already added to team drive.',
              null, options);
        } else {
          this.isSaving = false;
          let options = this.toastrOptions;
          this.toastr
            .error('Error while adding to team drive.',
              null, options);
        }
      }
    });
  }

  goToChildrenOfDrive(drive) {
    this.isSharePointSitesLoading = true;
    this.level = 3;
    setTimeout(() => {
      this.initializeSearchOnLevel3();
    }, 100);
    this.isFolderEmpty = false;
    this.selectedSiteData.drives.forEach(element => {
      if (element.id === drive.id) {
        this.selectedDriveId = drive.id;
        element.isSelected = true;
        element.children = [];
        this.selectedDriveData = element;
      }
    });
    // this._oneDriveService.getSharePointDriveChildrenByDriveId(drive.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.selectedSiteData.drives.forEach(element => {
    //         if (element.id === drive.id) {
    //           element.isSelected = true;
    //           element.children = result.responseData;
    //           element.children.forEach(child => {
    //             child.isSelected = false;
    //             if (this.showFolderOnly) {
    //               if (child.extension === 'folder') {
    //                 child.isShow = true;
    //               } else {
    //                 child.isShow = false;
    //               }
    //             } else {
    //               child.isShow = true;
    //             }
    //           });
    //           this.selectedDriveData = element;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //   }
    // });

    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(drive.id, undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        this.driveItems = [];
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.selectedSiteData.drives.forEach(element => {
              if (element.id === drive.id) {
                element.isSelected = true;
                element.children = result.responseData['item1'];
                element.children.forEach(child => {
                  child.isSelected = false;
                  if (this.showFolderOnly) {
                    if (child.extension === 'folder') {
                      child.isShow = true;
                    } else {
                      child.isShow = false;
                    }
                  } else {
                    child.isShow = true;
                  }
                });
                this.selectedDriveData = element;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      } else {
        // show error
      }
    });

  }

  getMoreChildrenOfDrive(event?: any) {
    if (this.nextBatchLink !== '' && !this.isMoreDataLoading) {
      this.isMoreDataLoading = true;
      this._oneDriveService.getMsFiles(this.selectedDriveId, undefined, this.nextBatchLink, undefined).subscribe(result => {
        this.isMoreDataLoading = false;
        if (!result.isError) {
          if (result.responseData) {
            if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
              this.selectedSiteData.drives.forEach(element => {
                if (element.id === this.selectedDriveId) {
                  element.isSelected = true;
                  element.children.push(...result.responseData['item1']);
                  element.children.forEach(child => {
                    child.isSelected = false;
                    if (this.showFolderOnly) {
                      if (child.extension === 'folder') {
                        child.isShow = true;
                      } else {
                        child.isShow = false;
                      }
                    } else {
                      child.isShow = true;
                    }
                  });
                  this.selectedDriveData = element;
                }
              });
            }
            if (result.responseData['item2']) {
              this.nextBatchLink = result.responseData['item2'];
            } else {
              this.nextBatchLink = '';
            }
          }
        }
      });
    }
  }

  backToSelectedDrive() {
    this.level = 2;
    this.selectedDriveData = null;
    this.isFolderEmpty = false;
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    this.isItemSelected = false;
    setTimeout(() => {
      this.initializeSearchOnLevel2();
    }, 100);
    this.selectedSiteData.drives.forEach(element => {
      element.isSelected = false;
      if (this.showFolderOnly) {
        if (element.extension === 'folder' || !element.extension) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      } else {
        element.isShow = true;
      }
    });
  }

  getDriveItems(item) {
    this.isSharePointSitesLoading = true;
    this.level = 5;
    setTimeout(() => {
      this.initializeSearchOnLevel5();
    }, 100);
    this.selectedItem.push(item);
    this.selectedDriveData.children.forEach(element => {
      if (element.id === item.id) {
        element.isSelected = true;
      }
    });
    this.isFolderEmpty = false;
    // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         if (this.showFolderOnly) {
    //           if (element.extension === 'folder') {
    //             element.isShow = true;
    //           } else {
    //             element.isShow = false;
    //           }
    //         } else {
    //           element.isShow = true;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });

    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.parentReference.driveId, item.parentReference.driveId === item.id ? undefined : item.id, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              if (this.showFolderOnly) {
                if (element.extension === 'folder') {
                  element.isShow = true;
                } else {
                  element.isShow = false;
                }
              } else {
                element.isShow = true;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  backToSelectedDriveItem() {
    this.level = 3;
    this.driveItems = [];
    this.isItemSelected = false;
    setTimeout(() => {
      this.initializeSearchOnLevel3();
    }, 100);
    this.selectedDriveData.children.forEach(element => {
      element.isSelected = false;
      if (this.showFolderOnly) {
        if (element.extension === 'folder') {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      } else {
        element.isShow = true;
      }
    });
  }

  goBack(): void {
    if (this.currentItemIndex > 0) {
      this.currentItemIndex--;
      this.driveItems = this.itemsHistory[this.currentItemIndex];
      this.driveItems.forEach(element => {
        element.isSelected = false;
        if (this.showFolderOnly) {
          if (element.extension === 'folder') {
            element.isShow = true;
          } else {
            element.isShow = false;
          }
        } else {
          element.isShow = true;
        }
      });
      this.itemsHistory.pop();
    } else {
      this.backToSelectLocation();
      // clear the item history
      this.itemsHistory = [];
    }
    this.isFolderEmpty = false;
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    if (this.selectedItem.length > 0) {
      this.selectedItem.pop();
    }
    this.isAllItemsSelected = false;
    this.isItemSelected = false;
  }

  goBackSP(): void {
    if (this.currentItemIndex > 0) {
      this.currentItemIndex--;
      this.driveItems = this.itemsHistory[this.currentItemIndex];
      this.driveItems.forEach(element => {
        element.isSelected = false;
        if (this.showFolderOnly) {
          if (element.extension === 'folder') {
            element.isShow = true;
          } else {
            element.isShow = false;
          }
        } else {
          element.isShow = true;
        }
      });
      this.itemsHistory.pop();
    } else {
      this.backToSelectedDriveItem();
      // clear the item history
      this.itemsHistory = [];
    }
    this.isFolderEmpty = false;
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    if (this.selectedItem.length > 0) {
      this.selectedItem.pop();
    }
    this.isAllItemsSelected = false;
    this.isItemSelected = false;
    if (this.itemsHistory.length === 1 && this.isFromProject) {
      this.level = 0;
    }
  }

  setItems(items: any[]): void {
    this.itemsHistory.push([...items]);
    this.currentItemIndex = this.itemsHistory.length - 1;
  }

  refreshItemsInItemsHistory(items: any[]): void {
    this.itemsHistory[this.currentItemIndex] = items;
  }

  goToL5FromL0(item: any): void {
    this.level = 5;
    this.removeSearchOnLevel5();
    this.isFolderEmpty = false;
    this.isSharePointSitesLoading = true;
    this.selectedItem.push(item);
    // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         if (this.showFolderOnly) {
    //           if (element.extension === 'folder') {
    //             element.isShow = true;
    //           } else {
    //             element.isShow = false;
    //           }
    //         } else {
    //           element.isShow = true;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });

    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.parentReference.driveId, item.parentReference.driveId === item.id ? undefined : item.id, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              if (this.showFolderOnly) {
                if (element.extension === 'folder') {
                  element.isShow = true;
                } else {
                  element.isShow = false;
                }
              } else {
                element.isShow = true;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  onItemSelected(item: any): void {
    this.removeSearchOnLevel4();
    this.isFolderEmpty = false;
    this.isSharePointSitesLoading = true;
    this.selectedItem.push(item);
    // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         if (this.showFolderOnly) {
    //           if (element.extension === 'folder') {
    //             element.isShow = true;
    //           } else {
    //             element.isShow = false;
    //           }
    //         } else {
    //           element.isShow = true;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });

    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.parentReference.driveId, item.parentReference.driveId === item.id ? undefined : item.id, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              if (this.showFolderOnly) {
                if (element.extension === 'folder') {
                  element.isShow = true;
                } else {
                  element.isShow = false;
                }
              } else {
                element.isShow = true;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  getMyFilesOnOneDrive(): void {
    this.isSharePointSitesLoading = true;
    this.level = 4;
    setTimeout(() => {
      this.initializeSearchOnLevel4();
    }, 100);
    this.nextBatchLink = '';
    this.selectedItem.push({ name: 'My Files' });
    // this._oneDriveService.getMyFilesOnOneDrive().subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         if (this.showFolderOnly) {
    //           if (element.extension === 'folder') {
    //             element.isShow = true;
    //           } else {
    //             element.isShow = false;
    //           }
    //         } else {
    //           element.isShow = true;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });
    this._oneDriveService.getMsFiles(undefined, undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              if (this.showFolderOnly) {
                if (element.extension === 'folder') {
                  element.isShow = true;
                } else {
                  element.isShow = false;
                }
              } else {
                element.isShow = true;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  getMoreMyFiles(event?: any) {
    if (this.nextBatchLink !== '' && !this.isMoreDataLoading) {
      this.isMoreDataLoading = true;
      this._oneDriveService.getMsFiles(undefined, undefined, this.nextBatchLink, undefined).subscribe(result => {
        this.isMoreDataLoading = false;
        if (!result.isError) {
          if (result.responseData) {
            if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
              this.driveItems.push(...result.responseData['item1']);
              this.driveItems.forEach(element => {
                element.isSelected = false;
                if (this.showFolderOnly) {
                  if (element.extension === 'folder') {
                    element.isShow = true;
                  } else {
                    element.isShow = false;
                  }
                } else {
                  element.isShow = true;
                }
              });
            }
            if (result.responseData['item2']) {
              this.nextBatchLink = result.responseData['item2'];
            } else {
              this.nextBatchLink = '';
            }
          }
        }
      });
    }
  }

  selectItem(item) {
    if (this.isSingleSelect) {
      this.driveItems.forEach(element => {
        element.isSelected = false;
      });
    }
    this.isAllItemsSelected = false;
    item.isSelected = !item.isSelected;
    this.isItemSelected = item.isSelected ? true : false;
  }

  selectAllItems() {
    this.isAllItemsSelected = !this.isAllItemsSelected;
    this.driveItems.forEach(element => {
      element.isSelected = this.isAllItemsSelected;
    });
  }

  selectItemAndSave(isOneDrive: boolean) {
    this.noOfSelectedItems = this.driveItems.filter(x => x.isSelected).length;
    if (this.noOfSelectedItems === 0) {
      let options = this.toastrOptions;
      this.toastr
        .error('Please select at least one item.',
          null, options);
      return;
    } else {
      this.selectedItems.emit([this.driveItems.filter(x => x.isSelected), null]);
    }
    this.driveItems.forEach(element => {
      if (element.isSelected) {
        this.noOfSelectedItems--;
      }
    });
    this.clickClose();
  }

  createLinkToItems(item, isOneDrive, noOfSelectedItems): void {
    let input: GroupLinkDto = new GroupLinkDto();

    input.type = 3; // 3 for shortcut
    input.name = item.name;
    if (!item.webUrl.startsWith('http')) {
      input.url = 'http://' + item.webUrl;
    } else {
      input.url = item.webUrl;
    }
    input.isShareFile = isOneDrive; // this.oneDrivePath ? true : false;
    input.isEveryone = true;
    // input.path = this.groupLinkObj.path;
    input.keyId = item.id;
    input.extension = item.extension;
    input.driveCategoryId = this.driveCategoryId;

    input.driveId = item.parentReference.driveId;
    input.siteId = item.parentReference.siteId;
    this._linkService.createOrUpdateGroupLink(input).subscribe(result => {
      if (!result.isError) {
        if (noOfSelectedItems === 1) {
          // this.dataService.refreshFilesSlider.next();
          let options = this.toastrOptions;
          this.toastr
            .success('Added to team drive.',
              null, options);
          this.clickClose();
          this.isSaving = false;
        }
      } else {
        if (result.errorMessage.toLocaleLowerCase() === 'duplicate') {
          this.isSaving = false;
          let options = this.toastrOptions;
          this.toastr
            .error('Item already added to team drive.',
              null, options);
        } else {
          this.isSaving = false;
          let options = this.toastrOptions;
          this.toastr
            .error('Error while adding to team drive.',
              null, options);
        }
      }
    });
  }

  selectAllDrives() {
    this.isAllDrivesSelected = !this.isAllDrivesSelected;
    if (this.selectedDriveData.children.length > 0) {
      this.selectedDriveData.children.forEach(element => {
        element.isSelected = this.isAllDrivesSelected;
      });
    }
  }

  selectDriveItem(item) {
    if (this.isSingleSelect) {
      this.selectedDriveData.children.forEach(element => {
        element.isSelected = false;
      });
    }
    this.isAllItemsSelected = false;
    item.isSelected = !item.isSelected;
    this.isItemSelected = item.isSelected ? true : false;
  }

  selectDriveItemAndSave() {
    this.noOfSelectedItems = this.selectedDriveData.children.filter(x => x.isSelected).length;
    if (this.noOfSelectedItems === 0) {
      let options = this.toastrOptions;
      this.toastr
        .error('Please select at least one item.',
          null, options);
      return;
    } else {
      let tmp = this.selectedDriveData.children.filter(x => x.isSelected);
      this.selectedItems.emit([tmp, null]);
    }
    this.selectedDriveData.children.forEach(element => {
      if (element.isSelected) {
        this.noOfSelectedItems--;
      }
    });
    this.clickClose();
  }

  applySearchOnLevel2() {
    if (this.selectedSiteData.drives.length > 0) {
      this.selectedSiteData.drives.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL2.toLowerCase()) > -1) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel2();
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel2() {
    let noOfIsShowItems = this.selectedSiteData.drives.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel2() {
    this.searchTextOnL2 = '';
    if (this.selectedSiteData.drives.length > 0) {
      this.selectedSiteData.drives.forEach(element => {
        element.isShow = true;
      });
      this.checkIfItemsToShowOnLevel2();
    } else {
      this.noResultFound = false;
    }
  }

  applySearchOnLevel3() {
    if (this.selectedDriveData.children.length > 0) {
      this.selectedDriveData.children.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL3.toLowerCase()) > -1) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel3();
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel3() {
    let noOfIsShowItems = this.selectedDriveData.children.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel3() {
    this.searchTextOnL3 = '';
    if (this.selectedDriveData.children.length > 0) {
      this.selectedDriveData.children.forEach(element => {
        element.isShow = true;
      });
      this.checkIfItemsToShowOnLevel3();
    } else {
      this.noResultFound = false;
    }
  }

  applySearchOnLevel4() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL4.toLowerCase()) > -1) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel4();
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel4() {
    let noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel4() {
    this.searchTextOnL4 = '';
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isShow = true;
      });
      this.checkIfItemsToShowOnLevel4();
    } else {
      this.noResultFound = false;
    }
  }

  applySearchOnLevel5() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL5.toLowerCase()) > -1) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel5();
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel5() {
    let noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel5() {
    this.searchTextOnL5 = '';
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isShow = true;
      });
      this.checkIfItemsToShowOnLevel5();
    } else {
      this.noResultFound = false;
    }
  }

  applySearchOnLevel0() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL0.toLowerCase()) > -1) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel0();
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel0() {
    let noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel0() {
    this.searchTextOnL0 = '';
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isShow = true;
      });
      this.checkIfItemsToShowOnLevel0();
    } else {
      this.noResultFound = false;
    }
  }

  onNewLibKeyPress(event: any): boolean {
    if (event.keyCode === 13) {
      this.createLibrary(event);
    }
    return event.keyCode !== 13;
  }

  onNewLibBlur(event: any) {
    let value: string = event.target.innerText.trim();
    if (value.length === 0) {
      this.isShowAddLibrary = false;
      return;
    }
    this.createLibrary(event);
  }

  private createLibrary(event) {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    this.isSaving = true;
    let input: CreateFolderDto = new CreateFolderDto();
    input.name = value;
    input.siteId = this.selectedSiteData.id;
    this._oneDriveService.createDocumentLibrary(input).subscribe(result => {
      if (!result.isError) {
        this.isSaving = false;
        event.target.innerText = '';
        this.goToDrivesBySiteId(this.selectedSiteData);
        // this.getSharepointSites();
        let options = this.toastrOptions;
        this.toastr
          .success('Library created successfully.',
            null, options);
      } else {
        this.isSaving = false;
        let options = this.toastrOptions;
        this.toastr
          .error('Error while creating library.',
            null, options);
      }
    });
  }

  showAddLibrary() {
    this.isShowAddLibrary = true;
    setTimeout(() => {
      $('.create-library').trigger('focus');
    }, 750);
  }

  showAddItem(type) {
    this.isShowAddItem = true;
    this.selectedDocType = type;
    setTimeout(() => {
      if (this.selectedDocType !== 5) {
        $('#create-file-input').trigger('focus');
      } else if (this.selectedDocType === 5) {
        $('#create-folder-input').trigger('focus');
      }
    }, 750);
  }

  selectDocType(type) {
    this.selectedDocType = type;
  }

  autoFillTitle(): void {
    this.documentName = '';
    this.documentName = this.documentName !== '' ? this.documentName + ' ' + this.sanitizeFilename(this.folderDetails.projectName) : this.sanitizeFilename(this.folderDetails.projectName);
    if (this.selectedDocType === 5) {
      $('#create-folder-input').val(this.documentName);
    }
    if (this.selectedDocType !== 5) {
      $('#create-file-input').val(this.documentName);
    }
    setTimeout(() => {
      if (this.selectedDocType === 5) {
        $('#create-folder-input').trigger('blur');
      } else {
        $('#create-file-input').trigger('blur');
      }
    }, 50);
  }

  onNewFileKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      if (level === 0) {
        this.createFileOnLevel0(event, isOneDrive, level);
      } else {
        this.createFile(event, isOneDrive, level);
      }
    }
    return event.keyCode !== 13;
  }

  onNewFileBlur(event: any, isOneDrive, level) {
    setTimeout(() => {
      let value: string = '';
      if (level === 0) {
        value = this.documentName.trim();
      } else {
        value = event.target.innerText.trim();
      }
      if (value.length > 0) {
        if (level === 0) {
          this.createFileOnLevel0(event, isOneDrive, level);
        } else {
          this.createFile(event, isOneDrive, level);
        }
      } else {
        this.isShowAddItem = false;
      }
    }, 500);
  }

  createFileOnLevel0(event, isOneDrive, level): void {
    let value: string = this.documentName.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFileInputDto = new CreateFileInputDto();
    input.isShareFile = true;
    input.isOneNote = this.selectedDocType === 4 ? true : false;

    input.driveId = this.folderDetails.driveId;
    input.itemId = this.folderDetails.itemId;
    // if (isOneDrive) {
    //   input.itemId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].id : '';
    //   input.driveId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
    // } else {
    //   if (level === 3) {
    //     // SharePoint Drive level
    //     input.driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
    //   } else {
    //     // SharePoint Items level
    //     input.itemId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].id : '';
    //     input.driveId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
    //   }
    // }
    input.name = value.trim();
    if (this.selectedDocType === 1) {
      input.extension = '.docx';
    } else if (this.selectedDocType === 2) {
      input.extension = '.xlsx';
    } else if (this.selectedDocType === 3) {
      input.extension = '.pptx';
    }
    this.isSaving = true;
    event.target.innerText = '';
    if (input.itemId === input.driveId) { input.itemId = undefined; }
    this._oneDriveService.createOneDriveFile(input).subscribe(result => {
      this.isSaving = false;
      this.documentName = '';
      this.isShowAddItem = false;
      if (!result.isError) {
        if (level !== 3) {
          if (level === 0) {
            this.refreshItemsOnL0(this.folderDetails);
          } else {
            this.refreshItems(this.selectedItem[this.selectedItem.length - 1]);
          }
        } else {
          this.goToChildrenOfDrive(this.selectedDriveData);
        }
      } else {
        if (result.errorMessage) {
          const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
          this.fsmShellError = { title: "Couldn't create this file", ...errorDef };
          this._fsmLastErrorCode = result.errorMessage;
          if (errorDef?.saveLabel) { this._fsmPendingFileInput = input; this._fsmPendingLevel = level; this._fsmPendingIsOneDrive = false; }
          this.fsmErrorShell.show();
        }
      }
    });
  }

  docNameChange(): void {
    this.fileNameError = false;
    this.fileNameErrorMessage = '';
  }

  createFile(event, isOneDrive, level): void {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFileInputDto = new CreateFileInputDto();
    input.isShareFile = true;
    input.isOneNote = this.selectedDocType === 4 ? true : false;
    if (isOneDrive) {
      input.itemId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].id : '';
      input.driveId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
    } else {
      if (level === 3) {
        // SharePoint Drive level
        input.driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
      } else {
        // SharePoint Items level
        input.itemId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].id : '';
        input.driveId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
      }
    }
    input.name = value.trim();
    if (this.selectedDocType === 1) {
      input.extension = '.docx';
    } else if (this.selectedDocType === 2) {
      input.extension = '.xlsx';
    } else if (this.selectedDocType === 3) {
      input.extension = '.pptx';
    }
    this.isSaving = true;
    event.target.innerText = '';
    if (input.itemId === input.driveId) { input.itemId = undefined; }
    this._oneDriveService.createOneDriveFile(input).subscribe(result => {
      this.isSaving = false;
      this.isShowAddItem = false;
      event.target.innerText = '';
      if (!result.isError) {
        if (level !== 3) {
          this.refreshItems(this.selectedItem[this.selectedItem.length - 1]);
        } else {
          this.goToChildrenOfDrive(this.selectedDriveData);
        }
        // //send object to edit task modals if created from task
        // let obj = {
        //   id: 0,
        //   filePath: result.responseData.url,
        //   fileName: result.responseData.fileName,
        //   fileType: input.isOneNote ? 'onenote' : input.extension,
        //   isShareFile: input.isShareFile,
        //   isAddToShortcut: false,
        //   keyId: result.responseData.keyId
        // };
        // if (this.selectedFileType === 'word') {
        //   obj.fileType = 'docx';
        // } else if (this.selectedFileType === 'excel') {
        //   obj.fileType = 'xlsx';
        // } else if (this.selectedFileType === 'powerpoint') {
        //   obj.fileType = 'pptx';
        // }
        // if (this.openedFrom && this.openedFrom === 'task') {
        //   this.dataService.createFileInTask.next(obj);
        // } else if (this.openedFrom && this.openedFrom === 'projectTask') {
        //   this.dataService.createFileInProjectTask.next(obj);
        // } else if (this.openedFrom && this.openedFrom === 'project') {
        //   this.dataService.createFileInProject.next(obj);
        // }
        // this.close();
      } else {
        if (result.errorMessage) {
          const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
          this.fsmShellError = { title: "Couldn't create this file", ...errorDef };
          this._fsmLastErrorCode = result.errorMessage;
          if (errorDef?.saveLabel) { this._fsmPendingFileInput = input; this._fsmPendingLevel = level; this._fsmPendingIsOneDrive = isOneDrive; }
          this.fsmErrorShell.show();
        }
        // if (result.errorMessage.includes('20117')) {
        //   this.fileNameError = true;
        //   this.fileNameErrorMessage = 'An item with this name already exists in this location.';
        // }
      }
    });
  }

  onNewFolderKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      if (level === 0) {
        this.createFolderOnLevel0(event, isOneDrive, level);
      } else {
        this.createFolder(event, isOneDrive, level);
      }
    }
    return event.keyCode !== 13;
  }

  onNewFolderBlur(event: any, isOneDrive, level) {
    setTimeout(() => {
      let value: string = '';
      if (level === 0) {
        value = this.documentName.trim();
      } else {
        value = event.target.innerText.trim();
      }
      if (value.length > 0) {
        if (level === 0) {
          this.createFolderOnLevel0(event, isOneDrive, level);
        } else {
          this.createFolder(event, isOneDrive, level);
        }
      } else {
        this.isShowAddItem = false;
      }
    }, 500);
  }

  createFolderOnLevel0(event, isOneDrive, level): void {
    let value: string = this.documentName.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFolderDto = new CreateFolderDto();
    input.isDocLibrary = false;
    input.isRename = false;
    input.driveId = this.folderDetails.driveId;
    input.itemId = this.folderDetails.itemId;

    input.name = value.trim();
    input.folderType = this.selectedItem.length === 1 ? 1 : 3;
    this.isSaving = true;
    event.target.innerText = '';
    this._oneDriveService.createFolder(input).subscribe(result => {
      this.isSaving = false;
      this.documentName = '';
      this.isShowAddItem = false;
      if (!result.isError) {
        if (level !== 3) {
          if (level === 0) {
            this.refreshItemsOnL0(this.folderDetails);
          } else {
            this.refreshItems(this.selectedItem[this.selectedItem.length - 1]);
          }
        } else {
          this.goToChildrenOfDrive(this.selectedDriveData);
        }
        // //send object to edit task modals if created from task
        // let obj = {
        //   id: 0,
        //   filePath: result.responseData.url,
        //   fileName: result.responseData.fileName,
        //   fileType: input.isOneNote ? 'onenote' : input.extension,
        //   isShareFile: input.isShareFile,
        //   isAddToShortcut: false,
        //   keyId: result.responseData.keyId
        // };
        // if (this.selectedFileType === 'word') {
        //   obj.fileType = 'docx';
        // } else if (this.selectedFileType === 'excel') {
        //   obj.fileType = 'xlsx';
        // } else if (this.selectedFileType === 'powerpoint') {
        //   obj.fileType = 'pptx';
        // }
        // if (this.openedFrom && this.openedFrom === 'task') {
        //   this.dataService.createFileInTask.next(obj);
        // } else if (this.openedFrom && this.openedFrom === 'projectTask') {
        //   this.dataService.createFileInProjectTask.next(obj);
        // } else if (this.openedFrom && this.openedFrom === 'project') {
        //   this.dataService.createFileInProject.next(obj);
        // }
        // this.close();
      } else {
        if (result.errorMessage) {
          const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
          this.fsmShellError = { title: "Couldn't create this folder", ...errorDef };
          this._fsmLastErrorCode = result.errorMessage;
          if (errorDef?.saveLabel) { this._fsmPendingFolderInput = input; this._fsmPendingLevel = level; this._fsmPendingIsOneDrive = false; }
          this.fsmErrorShell.show();
        }
        // if (result.errorMessage.includes('20117')) {
        //   this.fileNameError = true;
        //   this.fileNameErrorMessage = 'An item with this name already exists in this location.';
        // }
      }
    });
  }

  createFolder(event, isOneDrive, level): void {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFolderDto = new CreateFolderDto();
    input.isDocLibrary = false;
    input.isRename = false;
    if (isOneDrive) {
      input.itemId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].id : '';
      input.driveId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
    } else {
      if (level === 3) {
        // SharePoint Drive level
        input.driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
      } else {
        // SharePoint Items level
        input.itemId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].id : '';
        input.driveId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
      }
    }
    input.name = value.trim();
    input.folderType = this.selectedItem.length === 1 ? 1 : 3;
    this.isSaving = true;
    event.target.innerText = '';
    this._oneDriveService.createFolder(input).subscribe(result => {
      this.isSaving = false;
      event.target.innerText = '';
      this.isShowAddItem = false;
      if (!result.isError) {
        if (level !== 3) {
          this.refreshItems(this.selectedItem[this.selectedItem.length - 1]);
        } else {
          this.goToChildrenOfDrive(this.selectedDriveData);
        }
        // //send object to edit task modals if created from task
        // let obj = {
        //   id: 0,
        //   filePath: result.responseData.url,
        //   fileName: result.responseData.fileName,
        //   fileType: input.isOneNote ? 'onenote' : input.extension,
        //   isShareFile: input.isShareFile,
        //   isAddToShortcut: false,
        //   keyId: result.responseData.keyId
        // };
        // if (this.selectedFileType === 'word') {
        //   obj.fileType = 'docx';
        // } else if (this.selectedFileType === 'excel') {
        //   obj.fileType = 'xlsx';
        // } else if (this.selectedFileType === 'powerpoint') {
        //   obj.fileType = 'pptx';
        // }
        // if (this.openedFrom && this.openedFrom === 'task') {
        //   this.dataService.createFileInTask.next(obj);
        // } else if (this.openedFrom && this.openedFrom === 'projectTask') {
        //   this.dataService.createFileInProjectTask.next(obj);
        // } else if (this.openedFrom && this.openedFrom === 'project') {
        //   this.dataService.createFileInProject.next(obj);
        // }
        // this.close();
      } else {
        if (result.errorMessage) {
          const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
          this.fsmShellError = { title: "Couldn't create this folder", ...errorDef };
          this._fsmLastErrorCode = result.errorMessage;
          if (errorDef?.saveLabel) { this._fsmPendingFolderInput = input; this._fsmPendingLevel = level; this._fsmPendingIsOneDrive = isOneDrive; }
          this.fsmErrorShell.show();
        }
        // if (result.errorMessage.includes('20117')) {
        //   this.fileNameError = true;
        //   this.fileNameErrorMessage = 'An item with this name already exists in this location.';
        // }
      }
    });
  }

  okInfoPopupClicked(ev: any) {
    this.isShowInfoPopup = false;
  }

  fsmCloseError(): void {
    this.fsmErrorShell.hide();
    this.fsmShellError = undefined;
    this._fsmLastErrorCode = null;
    this._fsmPendingFileInput = null;
    this._fsmPendingFolderInput = null;
  }

  fsmSaveError(): void {
    this.fsmErrorShell.hide();
    this.fsmShellError = undefined;
    if (this._fsmPendingFolderInput) {
      const input = this._fsmPendingFolderInput;
      const level = this._fsmPendingLevel;
      const isOneDrive = this._fsmPendingIsOneDrive;
      this._fsmPendingFolderInput = null;
      if (this._fsmLastErrorCode === '101') {
        this.dataService.openRenameFileMobileModal.next({ fileName: input.name, skipRenameCall: true, extension: 'folder' });
        this.dataService.copyMoveRenameResult.pipe(take(1)).subscribe(newName => {
          if (!newName) { return; }
          input.name = newName;
          input.isUseExisting = false;
          this._fsmDoCreateFolder(input, level, isOneDrive);
        });
      } else if (this._fsmLastErrorCode === '106' || this._fsmLastErrorCode === '107' || this._fsmLastErrorCode === '114') {
        input.isUseExisting = false;
        this._fsmDoCreateFolder(input, level, isOneDrive);
      }
      return;
    }
    if (this._fsmPendingFileInput) {
      const input = this._fsmPendingFileInput;
      const level = this._fsmPendingLevel;
      const isOneDrive = this._fsmPendingIsOneDrive;
      this._fsmPendingFileInput = null;
      if (this._fsmLastErrorCode === '101') {
        this.dataService.openRenameFileMobileModal.next({
          fileName: input.name + (input.extension || ''),
          skipRenameCall: true,
        });
        this.dataService.copyMoveRenameResult.pipe(take(1)).subscribe(newName => {
          if (!newName) { return; }
          const ext = input.extension || '';
          input.name = (ext && newName.endsWith(ext)) ? newName.slice(0, -ext.length) : newName;
          input.duplicateAction = 0;
          this._fsmDoCreateFile(input, level, isOneDrive);
        });
      } else if (this._fsmLastErrorCode === '106' || this._fsmLastErrorCode === '107' || this._fsmLastErrorCode === '114') {
        input.duplicateAction = 0;
        this._fsmDoCreateFile(input, level, isOneDrive);
      }
      return;
    }
  }

  private _fsmDoCreateFile(input: CreateFileInputDto, level: number, isOneDrive: boolean): void {
    this.isSaving = true;
    this._oneDriveService.createOneDriveFile(input).subscribe(result => {
      this.isSaving = false;
      if (!result.isError) {
        this._fsmRefreshAfterCreate(level);
      } else if (result.errorMessage) {
        const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
        this.fsmShellError = { title: "Couldn't create this file", ...errorDef };
        this._fsmLastErrorCode = result.errorMessage;
        if (errorDef?.saveLabel) { this._fsmPendingFileInput = input; this._fsmPendingLevel = level; this._fsmPendingIsOneDrive = isOneDrive; }
        this.fsmErrorShell.show();
      }
    });
  }

  private _fsmDoCreateFolder(input: CreateFolderDto, level: number, isOneDrive: boolean): void {
    this.isSaving = true;
    this._oneDriveService.createFolder(input).subscribe(result => {
      this.isSaving = false;
      if (!result.isError) {
        this._fsmRefreshAfterCreate(level);
      } else if (result.errorMessage) {
        const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
        this.fsmShellError = { title: "Couldn't create this folder", ...errorDef };
        this._fsmLastErrorCode = result.errorMessage;
        if (errorDef?.saveLabel) { this._fsmPendingFolderInput = input; this._fsmPendingLevel = level; this._fsmPendingIsOneDrive = isOneDrive; }
        this.fsmErrorShell.show();
      }
    });
  }

  private _fsmRefreshAfterCreate(level: number): void {
    if (level === 0) {
      this.refreshItemsOnL0(this.folderDetails);
    } else if (level === 3) {
      this.goToChildrenOfDrive(this.selectedDriveData);
    } else {
      this.refreshItems(this.selectedItem[this.selectedItem.length - 1]);
    }
  }

  refreshItemsOnL0(item) {
    this.isFolderEmpty = false;
    this.isSharePointSitesLoading = true;
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.driveId ? item.driveId : undefined, item.itemId ? item.itemId : undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              if (this.showFolderOnly) {
                if (element.extension === 'folder') {
                  element.isShow = true;
                } else {
                  element.isShow = false;
                }
              } else {
                element.isShow = true;
              }
            });
            this.refreshItemsInItemsHistory(this.driveItems);
          } else {
            this.isFolderEmpty = true;
          }
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
    // if (item.id) {
    //   // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         if (this.showFolderOnly) {
    //   //           if (element.extension === 'folder') {
    //   //             element.isShow = true;
    //   //           } else {
    //   //             element.isShow = false;
    //   //           }
    //   //         } else {
    //   //           element.isShow = true;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //   }
    //   // });

    //   this.isSharePointSitesLoading = true;
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(item.id ? item.parentReference.driveId : undefined, item.id ? item.id : undefined, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             if (this.showFolderOnly) {
    //               if (element.extension === 'folder') {
    //                 element.isShow = true;
    //               } else {
    //                 element.isShow = false;
    //               }
    //             } else {
    //               element.isShow = true;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // } else {
    //   this.isSharePointSitesLoading = true;
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(undefined, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             if (this.showFolderOnly) {
    //               if (element.extension === 'folder') {
    //                 element.isShow = true;
    //               } else {
    //                 element.isShow = false;
    //               }
    //             } else {
    //               element.isShow = true;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // }
  }

  refreshItems(item) {
    this.isFolderEmpty = false;
    this.isSharePointSitesLoading = true;
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.id ? item.parentReference.driveId : undefined, item.id && item.parentReference?.driveId !== item.id ? item.id : undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              if (this.showFolderOnly) {
                if (element.extension === 'folder') {
                  element.isShow = true;
                } else {
                  element.isShow = false;
                }
              } else {
                element.isShow = true;
              }
            });
            this.refreshItemsInItemsHistory(this.driveItems);
          } else {
            this.isFolderEmpty = true;
          }
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
    // if (item.id) {
    //   // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         if (this.showFolderOnly) {
    //   //           if (element.extension === 'folder') {
    //   //             element.isShow = true;
    //   //           } else {
    //   //             element.isShow = false;
    //   //           }
    //   //         } else {
    //   //           element.isShow = true;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //   }
    //   // });

    //   this.isSharePointSitesLoading = true;
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(item.id ? item.parentReference.driveId : undefined, item.id ? item.id : undefined, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             if (this.showFolderOnly) {
    //               if (element.extension === 'folder') {
    //                 element.isShow = true;
    //               } else {
    //                 element.isShow = false;
    //               }
    //             } else {
    //               element.isShow = true;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // } else {
    //   this.isSharePointSitesLoading = true;
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(undefined, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             if (this.showFolderOnly) {
    //               if (element.extension === 'folder') {
    //                 element.isShow = true;
    //               } else {
    //                 element.isShow = false;
    //               }
    //             } else {
    //               element.isShow = true;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // }
  }

  triggerFileControlL3(): void {
    $('#fileUploadOneDrive_L3').trigger('click');
  }

  triggerFileControlL4(): void {
    $('#fileUploadOneDrive_L4').trigger('click');
  }

  triggerFileControlL5(): void {
    $('#fileUploadOneDrive_L5').trigger('click');
  }

  triggerFileControlL0(): void {
    $('#fileUploadOneDrive_L0').trigger('click');
  }

  fileInputChanged(event, isOneDrive, level): void {
    if (event.target.value) {
      if (event.target.files) {
        // Reset between invocations so a previously-rejected file doesn't
        // poison subsequent valid uploads.
        this.fileUploadError = false;
        this.fileErrorMsg = '';
        this.uploadingItems = [];
        let files = [];
        files = event.target.files;
        if (event.target.files.length > 0) {
          for (let index = 0; index < event.target.files.length; index++) {
            const element = event.target.files[index];
            if (element.size >= AppConsts.uploadFileSize) {
              this.toastr.error(`"${element.name}" is too large to upload. Maximum size is 25 MB.`, null, this.toastrOptions);
              this.fileUploadError = true;
              this.fileErrorMsg = 'Cannot upload file above 25mb.';
            } else if (element.size === 0) {
              this.toastr.error(`"${element.name}" is empty and can't be uploaded.`, null, this.toastrOptions);
              this.fileUploadError = true;
              this.fileErrorMsg = 'Cannot upload file with 0kb.';
            }
          }
          this.fileRawData = [];
          if (!this.fileUploadError) {
            let fileCts = event.target.files.length;
            for (let index = 0; index < event.target.files.length; index++) {
              const element = event.target.files[index];
              this.fileUploadError = false;
              this.fileCtrl = event.target.files[0].name;
              let file = element;
              this.fileRawData.push(file);
              fileCts--;
              if (fileCts <= 0) {
                this.isUploadFiles = true;
                if (level === 0) {
                  this.uploadFileForLevel0();
                } else {
                  this.uploadFileToSpecificFolder(isOneDrive, level);
                }
                event.target.value = null;
              }
            }
          } else {
            this.fileUploadError = false;
          }
        }
      }
    }
  }

  uploadFileForLevel0() {
    if (this.fileRawData.length > 0) {
      let fileCts = this.fileRawData.length;
      this.uploadingItems = [];
      let options = this.toastrOptions;
      this.toastr
        .success('We are uploading file(s). Please wait for a while.',
          null, options);
      this.fileRawData.forEach((element, index) => {
        let itemId = this.folderDetails.itemId;
        let driveId = this.folderDetails.driveId;
        // if (isOneDrive) {
        //   itemId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].id : '';
        //   driveId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
        // } else {
        //   if (level === 3) {
        //     // SharePoint Drive level
        //     driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
        //   } else {
        //     // SharePoint Items level
        //     itemId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].id : '';
        //     driveId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
        //   }
        // }
        if (driveId === itemId) {
          itemId = undefined;
        }
        this.isSaving = true;
        this._oneDriveService.uploadFile({ data: element, fileName: element.name } as FileParameter, driveId, itemId, 0).subscribe(result => {
          if (!result.isError) {
            fileCts--;
            if (fileCts <= 0) {
              this.isSaving = false;
              let options = this.toastrOptions;
              this.toastr
                .success('File(s) uploaded successfully.',
                  null, options);
              this.refreshItemsOnL0(this.folderDetails);
              // if (level !== 3) {
              //   this.refreshItems(this.selectedItem[this.selectedItem.length - 1]);
              // } else {
              //   this.goToChildrenOfDrive(this.selectedDriveData);
              // }
            }
          } else {
            this.isSaving = false;
            if (result.errorMessage) {
              const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
              this.fsmShellError = { title: "Couldn't upload this file", message: errorDef.message };
              this.fsmErrorShell.show();
            }
          }
        });
      });
    }
  }

  uploadFileToSpecificFolder(isOneDrive, level) {
    if (this.fileRawData.length > 0) {
      let fileCts = this.fileRawData.length;
      this.uploadingItems = [];
      let options = this.toastrOptions;
      this.toastr
        .success('We are uploading file(s). Please wait for a while.',
          null, options);
      this.fileRawData.forEach((element, index) => {
        let itemId = '';
        let driveId = '';
        if (isOneDrive) {
          itemId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].id : '';
          driveId = this.selectedItem.length > 1 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
        } else {
          if (level === 3) {
            // SharePoint Drive level
            driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
          } else {
            // SharePoint Items level
            itemId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].id : '';
            driveId = this.selectedItem.length > 0 ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
          }
        }
        if (driveId === itemId) {
          itemId = undefined;
        }
        this.isSaving = true;
        this._oneDriveService.uploadFile({ data: element, fileName: element.name } as FileParameter, driveId, itemId, 0).subscribe(result => {
          if (!result.isError) {
            fileCts--;
            if (fileCts <= 0) {
              this.isSaving = false;
              let options = this.toastrOptions;
              this.toastr
                .success('File(s) uploaded successfully.',
                  null, options);
              if (level !== 3) {
                this.refreshItems(this.selectedItem[this.selectedItem.length - 1]);
              } else {
                this.goToChildrenOfDrive(this.selectedDriveData);
              }
            }
          } else {
            this.isSaving = false;
            if (result.errorMessage) {
              const errorDef = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
              this.fsmShellError = { title: "Couldn't upload this file", message: errorDef.message };
              this.fsmErrorShell.show();
            }
          }
        });
      });
    }
  }
}
